import { isDesktopApplication } from '@/Utils';
export function syncDesktopMainProcessLocalization(state) {
    if (!isDesktopApplication()) {
        return;
    }
    const bridge = window.electronRemoteBridge;
    if (!(bridge === null || bridge === void 0 ? void 0 : bridge.syncMainProcessLocalization)) {
        return;
    }
    void bridge.syncMainProcessLocalization(state).catch((error) => {
        console.error('Failed to sync desktop main process localization', error);
    });
}
